import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'

import { JumpLink } from '@aok/ui-elements'
import { ContextHeadline } from '@aok/text-elements'

import MacroContainer from '../../_layout/Macro/MacroContainer'
import defaultProps from '../../../utils/propTypes/defaultProps'
import { BREAKPOINT_1000, BREAKPOINT_1280, BREAKPOINT_600 } from '../../../utils/constants/breakpoints'
import { useWindowSize } from '../../../hooks/useWindowSize'

const M046 = ({ headline, jumpLinks }) => {
  const listRef = useRef(null)
  const [scrollToOffset, setScrollToOffset] = useState(76)
  const [windowWidth] = useWindowSize()

  useEffect(() => {
    if (window.innerWidth < BREAKPOINT_600) {
      setScrollToOffset(64)
    } else if (window.innerWidth < BREAKPOINT_1000) {
      setScrollToOffset(80)
    } else if (window.innerWidth < BREAKPOINT_1280) {
      setScrollToOffset(88)
    } else {
      setScrollToOffset(96)
    }
  }, [windowWidth])

  const renderedJumpLinks = jumpLinks?.map((jumpLink, index) => {
    return (
      <li key={index} className="mb-24 600:mb-16 ">
        <JumpLink
          contentAlign="start"
          offset={scrollToOffset}
          iconPosition="left"
          arrowDirection="down"
          targetId={`#${jumpLink.id}`}
          title={jumpLink.title}
        />
      </li>
    )
  })

  return (
    <MacroContainer dataTrackingName="M046">
      <ContextHeadline
        {...headline}
        className="
          font-buenos-aires font-semibold
          text-28 leading-36 text-005e3f
          mb-24
          1280:text-32 1280:leading-44
        "
      />
      <ul ref={listRef}>{renderedJumpLinks}</ul>
    </MacroContainer>
  )
}

M046.propTypes = {
  headline: PropTypes.shape({
    text: PropTypes.string,
  }),
  contentLoaded: PropTypes.bool,
}

M046.defaultProps = {
  headline: {
    text: defaultProps.HEADLINE,
  },
}

export default M046
